<template>
  <div class="modal-backdrop pt-4">
    <div class="card maincard borderradius10 col-lg-3 col-md-6 mt-md-4 col-11 p-0 mx-auto" :class="{'confirmCard' :verificationSuccess}" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0"  v-if="!verificationSuccess">
        <div class="modal-header borderradius10 backgroundcolor9 p-4">          
          <h5 class="modal-title fontsize18 black80 proximanova-bold ml-2 text-center" id="exampleModalLabel" v-if="userInfoValidateScreen">Get your checklist done to veify your account</h5>       
          <h5 class="modal-title fontsize18 black80 proximanova-bold ml-2 text-center" id="exampleModalLabel" v-if="aadharNumberVerificationScreen||aadharOTPVerificationScreen">Aadhar Verification</h5>          
          <button type="button" class="close" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body borderradius10 bodymodal11" id="accordion" :class="{'bodymodal11':aadharNumberVerificationScreen}">
            <!-- error message coming from surepass -->
            <div class="text-center">
              <span class="red proximanova-semibold fontsize12">{{userAadharObj.apiErrorText}}</span>
              <span class="red proximanova-semibold fontsize12" v-if="NoofTimesHitOTPBtn >= 2">You have reached limit to verify OTP for your Aadhar verification</span>
            </div>
            <!-- user info validation screen -->
            <div class="p-4" v-if="userInfoValidateScreen">
              <!-- handle API error message in user validation section -->
              <div class="text-center p-2">
                <span class="red proximanova-semibold fontsize12">{{Errormessage}}</span>
              </div>
                <div class="row text-center mt-4 mb-4 opacityfont-12 d-flex flex-column" v-if="loadingValidationConditions">
                  <img src="../assets/loadingIcon1.gif" class="pageloader mx-auto" width="40px" alt="loading">
                  <span class="proximanova-semibold black80 mt-2 fontsize12">Fetching user validations</span>
                  <span class="proximanova-semibold black80 mb-2 fontsize12">Please wait ...</span>
                </div>
                <div class="row opacityfont-12 d-flex flex-column" v-else>
                  <!-- display error message when users reach their daily limit -->
                <div class="d-flex col-10 p-2 mx-auto" v-if="userDataValidations.reachedMaxaadharAttempts">
                    <span class="red proximanova-semibold fontsize12">You've reached daily limit to access this functionality. please try after 24 hours.</span>
                </div>
                <div class="d-flex col-8 p-2 mx-auto">
                    <img src="../assets/verify_tick.svg" v-if="userDataValidations.profilePicture=='Y'" alt="verify" width="25px">
                    <img src="../assets/verify_aadhar.svg" v-if="userDataValidations.profilePicture=='N'" alt="verify" width="25px">
                    <span class="proximanova fontsize18 black ml-2" :class="{'linethrough' :userDataValidations.profilePicture=='Y', 'red':userDataValidations.profilePicture=='N'}">Profile Picture</span>
                </div>
                <div class="d-flex col-8 p-2 mx-auto">
                    <img src="../assets/verify_tick.svg" v-if="userDataValidations.videoUpload=='Y'" alt="verify" width="25px">
                    <img src="../assets/verify_aadhar.svg" v-if="userDataValidations.videoUpload=='N'" alt="verify" width="25px">
                    <span class="proximanova fontsize18 black ml-2" :class="{'linethrough' :userDataValidations.videoUpload=='Y', 'red':userDataValidations.videoUpload=='N'}">1 Video Upload</span>
                </div>
                <div class="d-flex col-8 p-2 mx-auto">
                    <img src="../assets/verify_tick.svg" v-if="userDataValidations.profile=='Y'" alt="verify" width="25px">
                    <img src="../assets/verify_aadhar.svg" v-if="userDataValidations.profile=='N'" alt="verify" width="25px">
                    <span class="proximanova fontsize18 black ml-2" :class="{'linethrough' :userDataValidations.profile=='Y', 'red':userDataValidations.profile=='N'}">60% Profile</span>
                </div>
                <div class="d-flex col-8 p-2 mx-auto">
                    <img src="../assets/verify_tick.svg" v-if="userDataValidations.location=='Y'" alt="verify" width="25px">
                    <img src="../assets/verify_aadhar.svg" v-if="userDataValidations.location=='N'" alt="verify" width="25px">
                    <span class="proximanova fontsize18 black ml-2" :class="{'linethrough' :userDataValidations.location=='Y', 'red':userDataValidations.location=='N'}">Current Location</span>
                </div>
                </div>
            </div>
            <div class="fontsize14 black p-3" v-if="userInfoValidateScreen"><span class="proximanova-bold">Note : </span><span class="proximanova">{{noteContent}}</span></div>
            <!-- aadhar verification screen -->
            <div class="p-2 pl-4 pr-4 d-flex flex-column text-center" v-if="aadharNumberVerificationScreen">
              <!-- error message when users reach their daily limit -->
                <div class="d-flex col-12 p-2 mx-auto" v-if="userDataValidations.reachedMaxaadharAttempts">
                    <span class="red proximanova-semibold fontsize12">You've reached daily limit to access this functionality. please try after 24 hours.</span>
                </div>
                <img src="../assets/verify_finer_print.svg" alt="verify" class="col-4 mx-auto mt-1">
                <span class="proximanova fontsize14 black mt-3">You need to enter your aadhar number and <br>
                 click on proceed button</span>
                <div class="d-flex flex-column text-left mt-4">
                  <label for="aadharnumber" class="proximanova fontsize16 black">Aadhar Number</label>
                  <input type="text" id="aadharnumber" class="p-2 pl-3 fontsize16 black borderradius5 borderblack60" @input="aadharNumberRegexValidation" @keyup="aadharformat" placeholder="XXXX - XXXX - XXXX" v-model="userAadharObj.NormaladharCardNumber">
                  <!-- aadhar number validations -->
                  <div class="text-center pt-2">
                    <span class="red proximanova-semibold fontsize12">{{Errormessage}}</span>
                  </div>
                </div>
                <div class="fontsize14 black pt-3"><span class="proximanova-bold">Note : </span><span class="proximanova">You can only use this functionality twice in a day.</span></div>
            </div>
            <div class="p-2 pl-4 pr-4 d-flex flex-column text-center" v-if="aadharOTPVerificationScreen">
                <img src="../assets/verify_finer_print.svg" alt="verify" class="col-4 mx-auto">
                <span class="proximanova fontsize14 black mt-3">you need to enter OTP recevied on xxxxxx no.<br>
                 click on submit button</span>
                <div class="d-flex flex-column mt-4">
                    <label for="aadharnumber" class="proximanova fontsize16 black">OTP</label>
                    <input type="text" id="aadharnumber" class="p-2 pl-3 fontsize16 black borderradius5 borderblack60" @input="otpRegexValidation" placeholder="XXXXXX" maxlength="6" v-model="userAadharObj.otpValue">
                    <div class="text-center pt-2">
                      <span class="red proximanova-semibold fontsize12">{{Errormessage}}</span>
                    </div>
                </div>
                <div class="fontsize14 black pt-3"><span class="proximanova-bold">Note : </span><span class="proximanova">Please enter valid OTP. You are not allowed enter OTP more than 2 times.</span></div>
            </div>
        </div>
        <div class="modal-footer">
          <img src="../assets/uploadvideo.svg" alt="uploading" width="30px" class="img-fluid mx-auto ml-1" v-if="startLoadingAnimation">
          <button class="col-11 mr-3 btn backgroundcolor3 white borderradius20 sign-up-button" v-if="userInfoValidateScreen" @click="moveToAadharVerifyScreen">
            <span class="button-create-font proximanova">Continue</span>
          </button>
          <button class="col-11 mr-3 btn backgroundcolor3 white borderradius20 sign-up-button" v-if="aadharNumberVerificationScreen && !startLoadingAnimation" :disabled="Errormessage.length > 0 || !userAadharObj.NormaladharCardNumber || userDataValidations.reachedMaxaadharAttempts" @click="verifyAadharCardNumber">
            <span class="button-create-font proximanova">Proceed</span>
          </button>
          <button class="col-11 mr-3 btn backgroundcolor3 white borderradius20 sign-up-button" v-if="aadharOTPVerificationScreen && !startLoadingAnimation" :disabled="Errormessage.length > 0 || userAadharObj.otpValue.length != 6 || NoofTimesHitOTPBtn >= 2" @click="submitOTPBtnClicked">
            <span class="button-create-font proximanova">Submit</span>
          </button>
        </div>
      </div>
      <div class="modal-content border-0" v-if="verificationSuccess">
        <div class="modal-body borderradius10 backgroundcolorwhite p-5 text-center d-flex flex-column">
          <img src="../assets/verify_blue.svg" alt="verify" width="60px" class="mx-auto">
          <span class="mt-2 proximanova-bold fontsize24 blue">Verification is under Review</span>
          <span class="mt-2 proximanova fontsize12 black">Our verification team get back to you within 24 hours</span>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
      <div class="modal-content border-0 borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
            <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
            <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
            <button class="backgroundcolor3 white bordernone proximanova mt-4 p-1 borderadius12" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
import httpaadharverify from '@/js/http-aadhar_api.js'
import $ from 'jquery'
export default{
   data() {
    return{
      profileId : null,
      noteContent : "To move to aadhar verification, user profile should match with above requirements.",
      submitBtndisabled : false,
      displayAPIerrorModal : false,
      loadingValidationConditions : true,
      userDataValidations : {},
      //modal sections
      userInfoValidateScreen : true,
      aadharNumberVerificationScreen : false,
      aadharOTPVerificationScreen : false,
      verificationSuccess : false,
      //aadharregexvalidation
      Errormessage : '',
      startLoadingAnimation : false,
      NoofTimesHitOTPBtn : 0,
      //aadhar object to save
      userAadharObj : {
        profileId : sessionUtils.getUserProfileId(),
        aadharValidatationCase : true,
        NormaladharCardNumber : null,
        adharCardNumber : null,
        otpValue : "",
        clientId : null,
        fullName : "",
        dob : "", 
        gender : "", 
        country : "",
        dist : "", 
        state : "",
        vtc : "", 
        street : "",
        house : "",
        landmark : "", 
        zip : "",
        profileImage : "",
        referenceId : null,
        apiErrorText : "",
        isAadharValdid : false,
        otpSent : false,
        otpVerified : false
      }
    }
  },
  props : [
      'userProfileDetails'
  ],
  methods:{
    close(status) {
        this.$emit('closeUserVerificationmodal', status);
    },
    // move to aadhar card number verification screen if user validated all the conditions for verification
    moveToAadharVerifyScreen() {
      if(this.userDataValidations.profilePicture=='Y' && this.userDataValidations.videoUpload=='Y' && this.userDataValidations.profile=='Y' && this.userDataValidations.location=='Y' && !this.userDataValidations.reachedMaxaadharAttempts){
        this.userInfoValidateScreen = false;
        this.aadharNumberVerificationScreen = true;
        this.aadharOTPVerificationScreen = false;
        this.verificationSuccess = false;
      }else{
        var vm = this;
        vm.$toast.error("Please validate above conditions")
      }
    },
    aadharformat() {
      this.userAadharObj.NormaladharCardNumber = this.userAadharObj.NormaladharCardNumber.replace(/\D/g, "").split(/(?:([\d]{4}))/g).filter(s => s.length > 0).join(" ");
    },
    aadharNumberRegexValidation() {
      this.userAadharObj.apiErrorText = ''
      var regexp=/^[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}$/;
      var x=this.userAadharObj.NormaladharCardNumber;

      if(regexp.test(x)){
        console.log("Valid Aadhar no.");
        this.Errormessage = ''
      }else{ 
        console.log("Invalid Aadhar no.");
        this.Errormessage = "Please enter valid Aadhar Card Number"
      }
    },
    otpRegexValidation() {
      var regex = /^(\d\s*){6}$/g;
      var x = this.userAadharObj.otpValue;
      if(regex.test(x)){
        console.log("Valid OTP");
        this.Errormessage = ''
      }else{ 
        console.log("Invalid OTP");
        this.Errormessage = "Please enter valid OTP"
      }
    },
    //verify aadhar card number
    // call surpass API to get otp to the mobile number
    // once get the success response move to otp screen
    verifyAadharCardNumber() {
      console.log("final obj : ", this.userAadharObj)
      var vm = this;
      this.startLoadingAnimation = true;
      vm.userAadharObj.apiErrorText = "";
      let number = this.userAadharObj.NormaladharCardNumber
      number = number.replace(/ +/g, "")
      let obj = {
        id_number : number
      }
      this.userAadharObj.adharCardNumber = this.CryptoJS.AES.encrypt(this.userAadharObj.NormaladharCardNumber, "seCRET").toString()
      console.log("obj : ", obj)
      this.Errormessage = "";
      httpaadharverify.post('aadhaar-v2/generate-otp',obj)
      .then((response) => {
        console.log("get otp : ", response.data)
        // this.userAadharObj.clientId = response.data.data.client_id;
        // this.userAadharObj.isAadharValdid = response.data.data.valid_aadhaar;
        // this.userAadharObj.otpSent = response.data.data.otp_sent;
        setAadharVerificationData(response.data)
        console.log("user aadhar obj in then block: ", this.userAadharObj)
        this.updateUserVerificationInfo('aadhar_verification', 'SUCCESS')
      }).catch((e) => {
        console.log(e.response)
        if(e.response.status != 401){
          setAadharVerificationData(e.response.data)
          this.Errormessage = e.response.data.message;
          console.log("user aadhar obj in e block : ", this.userAadharObj)
          this.updateUserVerificationInfo('aadhar_verification', 'FAIL')
        }else{
          this.Errormessage = e.response.data.message;
          this.startLoadingAnimation = false;
        }
      })
      //set aadhar data
      function setAadharVerificationData(aadhardata) {
        console.log("after verify data : ", aadhardata)
        vm.userAadharObj.clientId = aadhardata.data.client_id;
        vm.userAadharObj.isAadharValdid = aadhardata.data.valid_aadhaar;
        vm.userAadharObj.otpSent = aadhardata.data.otp_sent;
        if(aadhardata.status_code != 200){
        vm.userAadharObj.apiErrorText = aadhardata.message;
        }
      }
      //prev
      // this.userInfoValidateScreen = false;
      // this.aadharNumberVerificationScreen = false;
      // this.aadharOTPVerificationScreen = true;
      // this.verificationSuccess = false;
    },
    submitOTPBtnClicked() {
      this.startLoadingAnimation = true;
      var vm = this;
      this.NoofTimesHitOTPBtn = this.NoofTimesHitOTPBtn + 1;
      let obj = {
        client_id : this.userAadharObj.clientId,
        otp : this.userAadharObj.otpValue
      }
      this.Errormessage = ""
      httpaadharverify.post('aadhaar-v2/submit-otp',obj)
      .then((response) => {
        console.log("submit otp : ", response)
        // let responsedata = response.data.data;
        // this.userAadharObj.otpVerified = response.data.success;
        // this.userAadharObj.referenceId = responsedata.reference_id;
        // this.userAadharObj.fullName = responsedata.full_name;
        // this.userAadharObj.dob = responsedata.dob;
        // this.userAadharObj.gender = responsedata.gender;
        // this.userAadharObj.country = responsedata.address.country;
        // this.userAadharObj.dist = responsedata.address.dist;
        // this.userAadharObj.state = responsedata.address.state;
        // this.userAadharObj.vtc = responsedata.address.vtc;
        // this.userAadharObj.street = responsedata.address.street;
        // this.userAadharObj.house = responsedata.address.house;
        // this.userAadharObj.landmark = responsedata.address.landmark;
        // this.userAadharObj.zip = responsedata.zip;
        // this.userAadharObj.profileImage = responsedata.profile_image;
        // this.userAadharObj.aadharValidatationCase = false;
        setOtpVerificationData(response.data)
        console.log("after verification", this.userAadharObj)
        this.updateUserVerificationInfo('otp_verification', 'SUCCESS')
      }).catch((e) => {
        console.log(e.response)
        if(e.response.status != 401){
          setOtpVerificationData(e.response.data)
          this.Errormessage = e.response.data.message;
          this.updateUserVerificationInfo('otp_verification', 'FAIL')
        }else{
          this.Errormessage = e.response.data.message;
          this.startLoadingAnimation = false;
        }
      })
      //set otp data
      function setOtpVerificationData(otpdata) {
        vm.userAadharObj.otpVerified = otpdata.success;
        if(otpdata.data){
        vm.userAadharObj.referenceId = otpdata.data.reference_id;
        vm.userAadharObj.fullName = otpdata.data.full_name;
        vm.userAadharObj.dob = otpdata.data.dob;
        vm.userAadharObj.gender = otpdata.data.gender;
        vm.userAadharObj.country = otpdata.data.address.country;
        vm.userAadharObj.dist = otpdata.data.address.dist;
        vm.userAadharObj.state = otpdata.data.address.state;
        vm.userAadharObj.vtc = otpdata.data.address.vtc;
        vm.userAadharObj.street = otpdata.data.address.street;
        vm.userAadharObj.house = otpdata.data.address.house;
        vm.userAadharObj.landmark = otpdata.data.address.landmark;
        vm.userAadharObj.zip = otpdata.data.zip;
        vm.userAadharObj.profileImage = otpdata.data.profile_image;
        }
        vm.userAadharObj.aadharValidatationCase = false;
        if(otpdata.status_code != 200){
        vm.userAadharObj.apiErrorText = otpdata.message;
        }
      }
      //prev
      // this.userInfoValidateScreen = false;
      // this.aadharNumberVerificationScreen = false;
      // this.aadharOTPVerificationScreen = false;
      // this.verificationSuccess = true;
      // setTimeout(() => {
      //     this.close()
      // }, 5000)
    },
    updateUserVerificationInfo(type, result) {
      httpuserprofile.post('/userprofile/aadharVerification', this.userAadharObj)
      .then((response) => {
        console.log(" after "+ type + " : " , response)
        this.startLoadingAnimation = false;
        this.getUserAccountVerifiedDetails()
        if(type == 'aadhar_verification' && result == 'SUCCESS'){
          this.userInfoValidateScreen = false;
          this.aadharNumberVerificationScreen = false;
          this.aadharOTPVerificationScreen = true;
          this.verificationSuccess = false;
          this.NoofTimesHitOTPBtn = 0;
          this.Errormessage = "";
        }
        if(type == 'otp_verification' && result == 'SUCCESS'){
          this.userInfoValidateScreen = false;
          this.aadharNumberVerificationScreen = false;
          this.aadharOTPVerificationScreen = false;
          this.verificationSuccess = true;
          setTimeout(() => {
            this.close('SUCCESS')
          }, 5000)
        }
      }).catch((e) => {
        console.log(e)
        this.startLoadingAnimation = false;
      })
    },
    // fetch user verification checklist
    getUserAccountVerifiedDetails() {
      httpuserprofile.get('/userprofile/aadharCheckList?profileId='+this.profileId)
      .then((response) => {
        console.log("user validations : ", response.data)
        this.userDataValidations = response.data;
        this.loadingValidationConditions = false;
      }).catch((e) => {
        console.log(e);
        this.Errormessage = "Something went wrong. Please try after sometime"
        this.loadingValidationConditions = false;
      })
    }
  },
   mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    this.getUserAccountVerifiedDetails()
    console.log("verifymszbob : ", this.userProfileDetails)
  },

}

</script>

<style scoped>
@import '../css/modal.css';
</style>